module.exports = __webpack_public_path__ + "static/images/flag-thailand.1iKhTTD.svg";